export const labelFromStudent = (student: any): string => {
  return `${student.givenName} ${student.middleName} ${student.surname}`;
};
export const subLabelFromStudent = (student: any): string => {
  return `Student no: ${student.studentNo}, ${student.gender}, Born ${student.dob}`;
};
